(function () {
  const toggleBtn = document.querySelector('[data-hm-toggle]');
  const drawer = document.getElementById('hmMegaDrawer');
  const backdrop = document.querySelector('[data-hm-backdrop]');
  const closeBtn = document.querySelector('[data-hm-close]');
  const catBtns = Array.from(document.querySelectorAll('[data-hm-cat-btn]'));
  const panels = Array.from(document.querySelectorAll('[data-hm-panel]'));

  if (!toggleBtn || !drawer || !backdrop || !closeBtn) return;

  function openDrawer() {
    drawer.hidden = false;
    backdrop.hidden = false;
    toggleBtn.setAttribute('aria-expanded', 'true');

    // focus first category for accessibility
    const first = catBtns[0];
    if (first) first.focus();

    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    drawer.hidden = true;
    backdrop.hidden = true;
    toggleBtn.setAttribute('aria-expanded', 'false');
    toggleBtn.focus();
    document.removeEventListener('keydown', onKeydown);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeDrawer();
  }

  function activatePanel(panelId) {
    panels.forEach(p => {
      const isTarget = p.id === panelId;
      p.hidden = !isTarget;
      p.classList.toggle('is-active', isTarget);
    });

    catBtns.forEach(b => {
      const isTarget = b.getAttribute('data-hm-target') === panelId;
      b.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
    });
  }

  toggleBtn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);

  catBtns.forEach(btn => {
    const target = btn.getAttribute('data-hm-target');

    // click to activate
    btn.addEventListener('click', () => activatePanel(target));

    // hover to activate (desktop-like mega menu)
    btn.addEventListener('mouseenter', () => {
      if (window.matchMedia('(min-width: 750px)').matches) activatePanel(target);
    });

    // keyboard focus activates too
    btn.addEventListener('focus', () => activatePanel(target));
  });

})();
